import { createContext } from 'react';

var createNamedContext = function (name) {
  var context = /*#__PURE__*/createContext();
  context.displayName = name;
  return context;
};

var context = createNamedContext('NavigatorRouter');
export default context;